<div class="element-wrapper">
  <span class="icon icon__{{icon}}"></span>
  <div class="text-wrapper" [ngClass]="{'modal-link':modalData && modalTitle}">
    <span class="therapy-sub-title">{{subTitle}}</span>
    <span class="therapy-value {{classes}}" (click)="loadModal($event)"
          genTooltip
          genEllipsis

          [tooltipPosition]="'TOP'"
          [tooltipText]="value"
          [tooltipShow]="showTooltip"
          [reapply]="value"
          (tooltipStateEmit)="showTooltip = $event">{{value}}</span>
  </div>
</div>
